/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

export const INITIALIZED_SUCCESS = 'INITIALIZED_SUCCESS'
export const INITIALIZED_ERROR = 'INITIALIZED_ERROR'